<script lang="ts" setup>
import RoomieCard from '@lahaus-roomie/roomie/src/components/RoomieCard/index.vue'
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import RoomieTag from '@lahaus-roomie/roomie/src/components/RoomieTag/index.vue'

import IconCalendar from '@lahaus-roomie/roomie/src/assets/icons/calendar.svg'

import type { Props } from './types'
import './_index.scss'

import { getAreaLabel, getDeliveryTermLabel } from '@/utils/project'
import { convertNumberToWord } from '@/utils/number'

const props = defineProps<Props>()

const { t, n } = useI18n()

const goToProject = () => {
  const url = props.project.path

  const event = new CustomEvent('app-chat:send-message', {
    detail: {
      message: t('chatMessage', { project_name: props.project.name })
    }
  })
  document.dispatchEvent(event)

  return navigateTo(url, {
    open: {
      target: '_blank'
    }
  })
}

const cover = `${props.project.cover}?width=300`
</script>

<script lang="ts">
export default {
  name: 'AppChatRecommendationCard'
}
</script>

<template>
  <RoomieCard
    :id="`app-chat-recomendation-card-${project.code}`"
    class="app-chat-recomendation-card"
    :data-lh-id="`${screen}-app-chat-recomendation-card`"
    :src="cover"
    :alt="project.name">
    <template #figure>
      <div class="relative">
        <figure>
          <img :src="cover">
        </figure>

        <RoomieTag
          :id="`app-chat-recomendation-card-tag-${project.code}`"
          class="app-chat-recomendation-card__tag"
          variant="success"
          :label="getDeliveryTermLabel(project.delivered_at, t)">
          <template #icon>
            <IconCalendar class="!fill-success-800 pointer-events-none" />
          </template>
        </RoomieTag>
      </div>
    </template>

    <template #content>
      <div class="flex flex-col gap-12">
        <p class="text-carbon-800 text-18 font-medium truncate">
          {{ project.name }}
        </p>

        <div class="flex flex-col gap-4 text-14 text-carbon-600">
          <p class="truncate">
            · {{ project.neighborhood_label }}, {{ project.city_label }}
          </p>

          <p>
            · {{ t('from', { price: convertNumberToWord(project.price, 'millions', 1, n)}) }}
          </p>

          <p>
            · {{ getAreaLabel(project.typologies, t) }}
          </p>
        </div>
      </div>

      <RoomieButton
        :id="`app-chat-recomendation-card-see-more-${project.code}`"
        :data-lh-id="`${screen}-app-chat-recomendation-card-see-more`"
        class="mt-16 w-fit"
        size="sm"
        @click="goToProject">
        {{ t('seeMore') }}
      </RoomieButton>
    </template>
  </RoomieCard>
</template>

<i18n src="./i18n.json" lang="json" />
